module.exports = __webpack_public_path__ + "static/img/home_adv_photo1@2x.57ff3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/ourAdvantage/home_adv_photo1@2x.png
// module id = xfD/
// module chunks = 0